export const locale = {
  lang: 'id',
  data: {
    'WAITING': 'Menunggu persetujuan',
    'APPROVED': 'Disetujui',
    'REFUSED': 'Ditolak'
  }
};
